export const WAREHOUSE = {
  name: 'Đại học FPT Hà Nội',
  address: 'Khu Giáo dục và Đào tạo, Khu Công nghệ cao Hòa Lạc, Km29 Đại lộ Thăng Long, Xã Hòa Lạc, Thành phố Hà Nội',
  provinceName: 'Thành phố Hà Nội',
};

const FREE_SHIPPING_LABEL = 'Miễn phí vận chuyển (đã gồm trong giá sản phẩm)';

/** Phí ship luôn 0 — chi phí vận chuyển đã tính vào giá sản phẩm. */
export function quoteShipping(_goodsTotal, provinceName) {
  if (!provinceName) {
    return { fee: 0, label: FREE_SHIPPING_LABEL, zone: 'free' };
  }
  return { fee: 0, label: FREE_SHIPPING_LABEL, zone: 'free' };
}
